<template>
 
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span class="forgetTitle">找回密码</span>
    </div>
    <div class="inputBody">
      <el-form :model="retrievePasswordForm" :rules="retrievePasswordFormRules" ref="retrievePasswordForm">
        <el-form-item label="" prop="loginName">
          <el-input v-model="retrievePasswordForm.loginName" @blur="loginName()" placeholder="手机号/用户名"/>
        </el-form-item>
        <el-form-item label="" prop="imgCaptcha" style="margin-bottom: 60px;">
          <el-input class="imgCaptcha" v-model="retrievePasswordForm.imgCaptcha" placeholder="请输入图形验证码">
            <template slot="append">
              <el-link @click="getImgCaptcha()">
                <el-image :src="imgCaptcha"/>
              </el-link>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <div class="retrieveSubmit">
            <el-button class="retrieveButton" type="primary" @click="retrieveNext('retrievePasswordForm')"
                       :loading="loginLoading">下一步
            </el-button>
            <el-link type="primary" href="/login">使用已有账户登录</el-link>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "RetrievePassword",
  data() {
    return {
      retrievePasswordForm: {
        loginName: '',
        imgCaptcha: '',
      },
      imgCaptcha: '',
      loginLoading: false,
      retrievePasswordFormRules: {
        loginName: [
          {required: true, message: '请输入登录名或手机号', trigger: 'blur'},
        ],
        imgCaptcha: [
          {required: true, message: '请输入图片验证码', trigger: 'blur'},
        ]
      }
    }
  },
  methods: {
    // 获取验证码
    getImgCaptcha() {
      const that = this
      that.$http.get(that.$requestUrl.GET_IMG_CAPTCHA).then((res) => {
        let data = res.data;
        if (200 === data.code) {
          let image = data.data;
          that.imgCaptcha = 'data:image/png;base64,' + image;
        } else {
          that.$message.error(data.msg);
        }
      }).catch(() => {
        that.$message.error(that.$errorMessage.SEVER_ERROR);
      })
    },
    loginName(){
      // 验证用户名或手机号是否存在
      
    },
    // 下一步
    retrieveNext(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("resetShow", "2")
          this.$message({
            type: "success",
            message: "验证成功"
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  mounted() {
    this.getImgCaptcha();
  }
}
</script>

<style lang="scss">
.el-card {
  div {
    .forgetTitle {
      font-size: 16px;
      font-weight: bold;
    }
  }

  .inputBody {
    .imgCaptcha {
      margin-bottom: 100px;
      .el-input-group__append, .el-input-group__prepend {
        padding: 0;

        .el-image {
          display: flex;
          justify-content: center;

          img {
            height: 38px;
            width: 81px;
          }
        }
      }
    }

    .retrieveSubmit {
      display: flex;
      justify-content: space-between;

      .retrieveButton {
        padding: 12px 50px;
      }
    }
  }
}
</style>